import store from "@/store";

/**
 * The freight class a package's density gives - the NMFC density scale from
 * the server (defaults.freight.density_classes: [lb/ft³ at or above, class],
 * densest first). Inches and pounds in; null without dims and weight.
 */
export function densityClass(length, width, height, weight) {
    const cubicFeet = (Number(length) * Number(width) * Number(height)) / 1728
    if (!(cubicFeet > 0) || !(Number(weight) > 0))
        return null

    const density = Number(weight) / cubicFeet
    const scale = (store.state.settings.defaults.freight || {}).density_classes || []
    for (const [min, cls] of scale)
        if (density >= min)
            return cls
    return '500'
}

/** lb/ft³, one decimal, for showing beside the class */
export function density(length, width, height, weight) {
    const cubicFeet = (Number(length) * Number(width) * Number(height)) / 1728
    return cubicFeet > 0 && Number(weight) > 0 ? Math.round(Number(weight) / cubicFeet * 10) / 10 : null
}

/**
 * After a quote: reload the ship services when it named one this page has not
 * loaded - a trucking line quoted for the first time is a new service, and a
 * service picker showing it would otherwise be blank.
 */
export async function refreshServicesFor(ids) {
    const known = new Set((store.state.settings.defaults.shipping || []).map(s => String(s.value)))
    if (ids.some(id => id != null && !known.has(String(id))))
        await store.dispatch('shipping_refresh')
}

/**
 * Whether a freight offer can still be booked for this trucking line: for the
 * same line (SCAC), and more than 5 minutes from expiring (as the server checks).
 */
export function offerCurrent(offer, scac) {
    if (!offer || !offer.offer_id || !scac || String(offer.scac || '').toUpperCase() !== String(scac).toUpperCase())
        return false
    const expires = offer.expires ? new Date(offer.expires) : null
    return !!expires && expires.getTime() > Date.now() + 5 * 60 * 1000
}
